export default {
  /*
   *  layoutType;菜单展示类型，3/4
   *  placeholderUrl：如果是三宫格展示背景图片
   *  rowReverse:默认false,左右顺序调换
   *  noneMenuUrl:图片占位，没有菜单时用
   *  total://提醒事务数量
   *  menuIcon :菜单icon；
   *  bgUrl：菜单背景
   */
  menuTwoList: [
    [
      {
        label: "事件中心",
        value: 0,

        children: [
          // menuIcon: require("../assets/images/homeMenu/综合安防.png") total: "5",
          { label: "实时事件", value: "0", path: "/realTimeAlarm" },
          { label: "事件记录", value: "0", path: "/historyAlarm" },
          { label: "事件工单", value: "0", path: "/taskCenter/list" },
          {
            label: "事件配置",
            value: "0",
            path: "/deviceaccess/eventconfignew"
          }
        ]
      },
      {
        label: "视频监控",
        value: 1,
        children: [
          {
            label: "日常监控",
            value: "0",
            path: "/videoMonitoring"
          },
          {
            label: "巡逻任务",
            value: "0",
            path: "/videoPatrol/task"
          },
          // total: "10",
          {
            label: "巡逻计划",
            value: "0",
            path: "/videoPatrol/plan"
          },
          {
            label: "巡逻记录",
            value: "0",
            path: "/videoPatrol/history"
          }
        ]
      },
      {
        label: "电子巡更",
        value: 2,
        slotBottom: true,
        slotBottomImg: require("../assets/images/homeMenu/电子巡更.png"),
        // slotData: [
        //   {
        //     label: "待处理异常",
        //     total: "0",
        //     color: "#FFC300",
        //     icon: require("../assets/images/homeMenu/待处理异常.png")
        //   },
        //   {
        //     label: "待执行巡更",
        //     total: "0",
        //     color: "#7367F0",
        //     icon: require("../assets/images/homeMenu/待执行巡更.png")
        //   }
        // ],
        children: [
          {
            label: "巡更记录",
            value: "0",
            path: "/elePatrol-patrolrecord"
          },
          {
            label: "巡更计划",
            value: "0",
            path: "/elePatrol-patrolplan"
          }
        ]
      },
      {
        label: "人员布控",
        value: 3,
        children: [
          {
            label: "人员布控名单",
            value: "0",
            path: "/personMg"
          },
          {
            label: "人员布控任务",
            value: "0",
            path: "/controlManage/task"
          },
          {
            label: "人员轨迹",
            value: "0",
            path: "/personResearch"
          },
          {
            label: "人员布控记录",
            value: "0",
            path: "/controlManage/record"
          }
          // {
          //   label: "",
          //   value: "0",
          //   type: "img",
          //   bgUrl: require("../assets/images/homeMenu/人员布控.png")
          // }
        ]
      },
      {
        label: "车辆布控",
        value: 3,
        children: [
          {
            label: "车辆布控名单",
            value: "0",
            path: "/carPatrolBlack"
          },
          {
            label: "车辆布控任务",
            value: "0",
            path: "/controlManage/cartask" // 功能暂不实现
          },
          {
            label: "车辆轨迹",
            value: "0",
            path: "/carResearch"
          },
          {
            label: "",
            value: "0",
            type: "img",
            bgUrl: require("../assets/images/homeMenu/车辆布控.png")
          }
        ]
      },
      {
        label: "公共广播",
        value: 3,
        children: [
          {
            label: "音频管理",
            value: "0",
            path: "/broadcast/audio"
          },
          {
            label: "远程喊话",
            value: "0",
            path: "/broadcast/call"
          },
          {
            label: "广播联动",
            value: "0",
            path: "/broadcast/linkage"
          },
          {
            label: "",
            value: "0",
            type: "img",
            bgUrl: require("../assets/images/homeMenu/公共广播.png")
          }
        ]
      }
      // {
      //   noneMenuUrl:require("../assets/images/homeMenu/menubg.png")
      // },
    ],
    [
      {
        label: "出入口管理",
        value: 0,
        // layoutType: "3",
        // placeholderUrl: require("../assets/images/homeMenu/出入口管理Bg.png"),
        children: [
          {
            label: "出入口值守",
            value: "0",
            path: "/security/getwayControl"
          },
          {
            label: "远程控制记录",
            value: "0",
            path: "/security/getwayRecord"
          },
          {
            label: "",
            value: "0",
            type: "img",
            bgUrl: require("../assets/images/homeMenu/出入口管理Bg.png")
          },
          {
            label: "出入口配置",
            value: "0",
            path: "/security/getwayConfig"
          }
        ]
      },
      {
        label: "通行记录",
        value: 1,
        children: [
          {
            label: "访客拜访记录",
            value: "0",
            path: "/access/visitorRecord"
          },
          {
            label: "人员通行记录",
            value: "0",
            path: "/personAccessRecord/index"
          },
          {
            label: "车辆通行记录",
            value: "0",
            path: "/carAccessRecord/index"
          },
          {
            label: "",
            value: "0",
            type: "img",
            bgUrl: require("../assets/images/homeMenu/通行记录Bg.png")
          }
        ]
      },
      {
        label: "名单管理",
        value: 2,
        slotBottom: true,
        slotBottomImg: require("../assets/images/homeMenu/名单管理.png"),
        // slotData: [
        //   {
        //     label: "人员名单",
        //     total: "0",
        //     color: "#07B9B9",
        //     icon: require("../assets/images/homeMenu/人员名单.png")
        //   },
        //   {
        //     label: "车辆名单",
        //     total: "0",
        //     color: "FF8F1F ",
        //     icon: require("../assets/images/homeMenu/车辆名单.png")
        //   }
        // ],
        children: [
          {
            label: "人员名单库",
            value: "0",
            path: "/peopleInfo"
          },
          {
            label: "车辆名单库",
            value: "0",
            path: "/carInfo/index"
          }
        ]
      },
      {
        label: "通行授权",
        layoutType: 3,
        placeholderUrl: require("../assets/images/homeMenu/通行权限Bg.png"),
        children: [
          {
            label: "人员通行授权",
            value: "0",
            path: "/personAuthorization/index"
          },
          {
            label: "车辆通行授权",
            value: "0",
            path: "/carAuthorization/index"
          }
          // {
          //   label: "授权同步",
          //   value: "0"
          // },
          // {
          //   label: "",
          //   value: "0",
          //   type: "img",
          //   bgUrl: require("../assets/images/homeMenu/通行权限Bg.png")
          // }
        ]
      }
    ],
    [
      {
        label: "消防事件中心",
        value: 0,
        children: [
          {
            label: "消防实时事件",
            value: "0",
            path: "/fireAlarm"
          },
          // total: 120
          {
            label: "消防事件记录",
            value: "0",
            path: "/fireHistory"
          },
          {
            label: "消防事件工单",
            value: "0",
            path: "/fireTaskCenter/list"
          },
          {
            label: "消防事件配置",
            value: "0",
            path: "/deviceaccess/fireEventConfig"
          }
        ]
      },
      {
        label: "消防监控",
        value: 1,
        // layoutType: 3,
        // placeholderUrl: require("../assets/images/homeMenu/状态监控Bg.png"),
        children: [
          {
            label: "消防状态监控",
            value: "0",
            path: "/fireMonitor"
          },
          {
            label: "消防远程控制",
            value: "0",
            path: "/fireControl"
          },
          {
            label: "消防控制记录",
            value: "0",
            path: "/fireControlRecord"
          },
          {
            label: "",
            value: "0",
            type: "img",
            bgUrl: require("../assets/images/homeMenu/消防监控bg.png")
          }
        ]
      },
      {
        label: "防火巡查",
        value: 2,
        slotBottom: true,
        slotBottomImg: require("../assets/images/homeMenu/防火巡查.png"),
        // slotData: [
        //   {
        //     label: "待解决异常项",
        //     total: "",
        //     color: "#07B9B9",
        //     icon: require("../assets/images/homeMenu/人员名单.png")
        //   },
        //   {
        //     label: "最近一次巡查",
        //     total: "",
        //     color: "#FF8F1F ",
        //     icon: require("../assets/images/homeMenu/车辆名单.png")
        //   }
        // ],
        children: [
          {
            label: "防火巡查统计",
            value: "0",
            path: "/firePatrol/count"
          },
          {
            label: "巡查项管理",
            value: "0",
            path: "/firePatrol/items"
          }

          // {
          //   label: "巡查点位管理",
          //   value: "0"
          // },
          // {
          //   label: "",
          //   value: "0",
          //   type: "img",
          //   bgUrl: require("../assets/images/homeMenu/防火巡查Bg.png")
          // }
        ]
      }
      // {
      //   label: "消防设置",
      //   value: 3,
      //   layoutType: 3,
      //   placeholderUrl: require("../assets/images/homeMenu/消防设置Bg.png"),
      //   children: [
      //     {
      //       label: "消防预警设置",
      //       value: "0"
      //     },
      //     {
      //       label: "室内点位设置",
      //       value: "0"
      //     },
      //     {
      //       label: "事件配置",
      //       value: "0",
      //       path:"/deviceaccess/fireEventConfig"
      //     }
      //   ]
      // }
    ],
    [
      // {
      //   label: "基础档案",
      //   value: 0,
      //   children: [
      //     {
      //       label: "应急救援仓库",
      //       value: "0"
      //     },
      //     {
      //       label: "应急救援队伍",
      //       value: "0"
      //     },
      //     {
      //       label: "医疗机构档案",
      //       value: "0"
      //     },
      //     {
      //       label: "应急避难场所",
      //       value: "0"
      //     }
      //   ]
      // },
      // {
      //   label: "基础档案",
      //   value: 1,
      //   children: [
      //     {
      //       label: "应急工作组",
      //       value: "0"
      //     },
      //     {
      //       label: "应急专家库",
      //       value: "0"
      //     },
      //     {
      //       label: "重点防护目标",
      //       value: "0"
      //     },
      //     {
      //       label: "",
      //       value: "0",
      //       type: "img",
      //       bgUrl: require("../assets/images/homeMenu/应急工作组bg.png")
      //     }
      //   ]
      // },
      // {
      //   label: "联动配置",
      //   value: 2,
      //   // layoutType: 3,
      //   // placeholderUrl: require("../assets/images/homeMenu/threeTitle.png"),
      //   children: [
      //     {
      //       label: "出入口联动",
      //       value: "0"
      //     },
      //     {
      //       label: "广播联动",
      //       value: "0"
      //     },
      //     {
      //       label: "短信群发",
      //       value: "0"
      //     },
      //     {
      //       label: "",
      //       value: "0",
      //       type: "img",
      //       bgUrl: require("../assets/images/homeMenu/联动配置bg.png")
      //     }
      //   ]
      // },
      {
        label: "预案编制",
        value: 3,
        children: [
          {
            label: "预案编制",
            value: "0",
            path: "/reserve/reserveplan"
          },
          {
            label: "预案执行",
            value: "0",
            path: "/reserveImplement"
          },
          {
            label: "预案记录",
            value: "0",
            path: "/reserve/reserveRecord"
          },
          {
            label: "",
            value: "0",
            type: "img",
            bgUrl: require("../assets/images/homeMenu/预案编制bg.png")
          }
        ]
      },
      {
        label: "应急处置",
        value: 3,
        children: [
          {
            label: "应急处置卡",
            value: "0",
            path: "/workshop/emergency-handle-card"
          },
          {
            label: "应急处置流程",
            value: "0",
            path: "/workshop/emergency-handle"
          },
          {
            label: "应急组管理",
            value: "0",
            path: "/workshop/emergency-group"
          },
          {
            label: "",
            value: "0",
            type: "img",
            bgUrl: require("../assets/images/homeMenu/应急处理bg.png")
          }
        ]
      }
    ],
    [
      {
        label: "设备管理",
        value: 3,
        layoutType: 3,
        placeholderUrl: require("../assets/images/homeMenu/deviceManage.png"),
        children: [
          {
            label: "设备档案",
            value: "0",
            path: "/cameralist/devicelist"
          },
          // {
          //   label: "事件配置",
          //   value: "0"
          // },
          // {
          //   label: "设备分组",
          //   value: "0"
          // },
          {
            label: "设备接入",
            value: "0",
            path: "/deviceaccess/index"
          }
          // {
          //   label: "",
          //   value: "0",
          //   type: "img",
          //   bgUrl: require("../assets/images/homeMenu/deviceManage.png")
          // }
        ]
      },
      {
        label: "区域管理",
        value: 1,
        children: [
          {
            label: "区域管理",
            value: "0",
            path: "/area"
          },
          {
            label: "楼栋管理",
            value: "0",
            path: "/building/index"
          },
          {
            label: "车间管理",
            value: "0",
            path: "/workShopManage"
          },
          {
            label: "",
            value: "0",
            type: "img",
            bgUrl: require("../assets/images/homeMenu/spaceManage.png")
          }
        ]
      },
      {
        label: "用户管理",
        value: 2,
        children: [
          {
            label: "角色管理",
            value: "0",
            path: "/accountgroup"
          },
          {
            label: "账户管理",
            value: "0",
            path: "/account/index"
          },
          {
            label: "工作组管理",
            value: "0",
            path: "/workGroup/index"
          },
          {
            label: "保卫换岗记录",
            value: "0",
            path: "/securityShift"
          }
        ]
      },
      {
        label: "系统相关",
        value: 3,
        layoutType: 3,
        placeholderUrl: require("../assets/images/homeMenu/system.png"),
        children: [
          {
            label: "系统参数设置",
            value: "0",
            path: "/system"
          },
          {
            label: "日志管理",
            value: "0",
            path: "/log"
          }
        ]
      }
    ]
  ],
  /*
   *  value值顺序和menList一一对应，如更改请同步修改
   *  menuCode来源数据库
   *  rowReverse:默认false,左右顺序调换
   */
  menuList: [
    {
      label: "综合安防",
      value: 0,
      menuCode: "03",
      icon: require("../../common/assets/images/homeMenu/综合安防.png"),
      iconActive: require("../../common/assets/images/homeMenu/综合安防-active.png")
    },
    {
      label: "便捷通行",
      value: 1,
      menuCode: "04",
      icon: require("../../common/assets/images/homeMenu/便捷通行.png"),
      iconActive: require("../../common/assets/images/homeMenu/便捷通行-active.png")
    },
    {
      label: "消防管理",
      value: 2,
      menuCode: "05",
      icon: require("../../common/assets/images/homeMenu/消防管理.png"),
      iconActive: require("../../common/assets/images/homeMenu/消防管理-active.png")
    },
    {
      label: "预案联动",
      value: 3,
      menuCode: "06",
      icon: require("../../common/assets/images/homeMenu/预案联动.png"),
      iconActive: require("../../common/assets/images/homeMenu/预案联动.png")
    },
    {
      label: "系统基础",
      value: 4,
      menuCode: "99",
      icon: require("../../common/assets/images/homeMenu/系统基础.png"),
      iconActive: require("../../common/assets/images/homeMenu/系统基础-active.png")
    }
  ]
};
